import defaultSettings from '@/settings'

const title = defaultSettings.title || '项目管理'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${title} - ${pageTitle} `
  }
  return `${title}`
}
